"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isCompanyEmployee(object) {
    return checkCompanyEmployee(object).fulfilled;
}
exports.isCompanyEmployee = isCompanyEmployee;
function checkCompanyEmployee(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("employeeNumber").optional()).withOptions(options).explain();
}
exports.checkCompanyEmployee = checkCompanyEmployee;
//# sourceMappingURL=CompanyEmployee.js.map